/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

export default class InsightsController extends Controller {
  @service
  session;

  @service
  features;

  @service
  router;

  Jurisdiction = Jurisdiction;

  queryParams = [
    {
      includeFormers: {
        scope: 'controller',
      },
    },
  ];

  stickyPos = 72;
  includeFormers = false;

  @computed('router.currentRouteName')
  get currentTab() {
    // Extract the 3rd segment of the route name (group.insights.*) so that child routes still activate the tab.
    return this.router.currentRouteName.split('.').slice(2, 3)[0];
  }

  @computed('model.assessments.[]')
  get assessmentId() {
    return this.model.assessments
      .slice()
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''))[0]?.id;
  }

  @action
  noop() {}

  @action
  goToAssessmentProgress() {
    if (!this.assessmentId) {
      // The group has no assessments. Show the empty assessments tab.
      this.router.transitionTo(
        'group.insights.assessments.current',
        this.model.group.id,
      );
      return;
    }

    this.router.transitionTo(
      `group.insights.assessments.current.assessment`,
      this.model.group.id,
      this.assessmentId,
    );
  }
}
